interface ArtifactCardProps {
  icon: string;
  name: string;
  description: string;
  size: number;
  onDownload: () => void;
}

export default function ArtifactCard({
  icon,
  name,
  description,
  size,
  onDownload,
}: ArtifactCardProps) {
  const sizeLabel =
    size >= 1024 ? `${(size / 1024).toFixed(1)} KB` : `${size} B`;

  return (
    <div className="bg-slate-800/60 border border-slate-700/50 rounded-xl p-4 sm:p-5 flex items-center gap-4 hover:border-slate-600/50 transition-colors">
      <span className="text-2xl flex-shrink-0">{icon}</span>
      <div className="flex-1 min-w-0">
        <h3 className="text-sm sm:text-base font-medium text-white truncate">
          {name}
        </h3>
        <p className="text-xs sm:text-sm text-slate-400 mt-0.5">{description}</p>
        <p className="text-xs text-slate-500 mt-1">{sizeLabel}</p>
      </div>
      <button
        onClick={onDownload}
        className="flex-shrink-0 bg-blue-600 hover:bg-blue-500 text-white text-xs sm:text-sm font-medium rounded-lg px-3 py-1.5 transition-colors"
      >
        Download
      </button>
    </div>
  );
}
